import { withChartLayout } from 'components/common';
import PsychosocialInterventions from 'components/features/chart/system-nursing-interventions/psychosocial-interventions/PsychosocialInterventions';

const PsychosocialInterventionsPage = withChartLayout('Psychosocial Interventions')(PsychosocialInterventions);
export default PsychosocialInterventionsPage;
